import React, { FunctionComponent } from "react";
import "./index.scss";

type Props = {
  title: string;
  subText?: string;
}

export const PageTitle: FunctionComponent<Props> = (props: Props) => {
  return (
    <div className={"PageTitle"}>
      <div className={"title"}>
        {props.title}
      </div>
      {props.subText ? (
          <div className={"sub-text"}>
            {props.subText}
          </div>
        )
        : null
      }
    </div>
  );
};
